import * as React from 'react';
import { Link, RouteComponentProps } from '@reach/router';

type NotFoundPropsProps = RouteComponentProps<{}>;

function NotFound(props: NotFoundPropsProps) {
  return (
    <div>
      <h2>My Bad</h2>
      <p>You have found a path that I didn't account for.</p>
      <Link to="/">Home</Link>
    </div>
  );
}
export default NotFound;
